import { render, staticRenderFns } from "./subscription-purchase-auto.vue?vue&type=template&id=1496fc7e&scoped=true&"
import script from "./subscription-purchase-auto.vue?vue&type=script&lang=js&"
export * from "./subscription-purchase-auto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1496fc7e",
  null
  
)

export default component.exports